/**
 * Codes du choix de statut d'un formateur, stockés dans `teachr.procuration`
 * (chaîne) et dispatchés dans `state.user.currentProcuration` (nombre) :
 *   10 = Coopérative
 *   20 = Procuration SAP
 *   30 = Procuration AE + SAP
 *   40 = Déclaration SAP
 *
 * Avant la migration de mai 2026, l'AE valait 1 et le SAP 2. Ces anciens codes
 * restent tolérés : des comptes et des écrans historiques les utilisent encore.
 */
export const PROCURATION_COOPERATIVE = 10;
export const PROCURATION_SAP = 20;
export const PROCURATION_AE = 30;
export const PROCURATION_DECLARATION_SAP = 40;

export const LEGACY_PROCURATION_AE = 1;
export const LEGACY_PROCURATION_SAP = 2;

/**
 * Résout le code de procuration à utiliser pour un écran.
 *
 * Le code porté par le compte (`teachr.procuration`) prime : c'est lui que
 * l'écran de procuration utilise pour choisir le parcours affiché. La valeur
 * Redux (`state.user.currentProcuration`) ne sert que de repli, car elle est
 * persistée en localStorage et n'est pas remise à zéro à la déconnexion.
 */
export const resolveProcurationCode = (
  teachrProcuration: string | number | null | undefined,
  fallback: number | null | undefined,
): number => {
  const fromTeachr = typeof teachrProcuration === "number"
    ? teachrProcuration
    : parseInt(String(teachrProcuration ?? ""), 10);
  if (Number.isInteger(fromTeachr) && fromTeachr > 0) {
    return fromTeachr;
  }
  if (typeof fallback === "number" && Number.isInteger(fallback) && fallback > 0) {
    return fallback;
  }
  return 0;
};

export const isAeProcurationCode = (code: number | null | undefined): boolean =>
  code === PROCURATION_AE || code === LEGACY_PROCURATION_AE;

export const isSapProcurationCode = (code: number | null | undefined): boolean =>
  code === PROCURATION_SAP || code === LEGACY_PROCURATION_SAP;
